import { useRiskProfileRequest } from './useRiskProfileRequest'
import { useRiskProfileQuery } from './useRiskProfileQuery'
import type { RiskProfileQueryParams } from './useRiskProfileQueryParams'

export function useProfileHazardTypeData(queryParams: RiskProfileQueryParams | null) {
  const request = useRiskProfileRequest({ queryParams, widget: 'riskByHazardType' })
  const query = useRiskProfileQuery(request as Parameters<typeof useRiskProfileQuery>[0])
  return { request, query }
}
